import axios from 'axios';
import Cookies from 'js-cookie';
import { compact, join } from 'lodash';
import { v4 as uuid } from 'uuid';

import windowCheck from 'utils/helpers/window-check';

import todaysDate from '../helpers/todaysDate';

class API {
  static signup(formData) {
    return new Promise((resolve, reject) => {
      
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      };
      
      if (Cookies.get('branch')) {
        headers.Branch = Cookies.get('branch');
      }

      const ldAnonContextCookie = Cookies.get('ld_anon_context');

      if (ldAnonContextCookie) {
        headers['W-LDAnonymousId'] = ldAnonContextCookie;
      }

      const api = axios.create({
        baseURL: `${process.env.GATSBY_SIGNUP_ENDPOINT}`,
        headers,
      });
      
      const formattedData = this.formatData(formData);

      api
        .post(api.baseUrl, formattedData)
        .then(data => {
          resolve({ ...data, formattedData });
          console.table('success', data);
        })
        .catch(error => {
          reject(error);
          console.log('error', error);
        });
    });
  }

  static googleSignup(refPlanId, trialLength) {
    return new Promise((resolve, reject) => {
      const key = uuid();
      const domain = `${process.env.GATSBY_SITE_URL}`;

      let ref_page = null;
      if (windowCheck) {
        ref_page = window.currentLocation === '/' ? 'homepage' : window.currentLocation;
      }

      const cookieData = {
        redirectUrl: '/create/new',
        ref_page: ref_page,
        ref_plan_id: refPlanId,
        trial_length: trialLength,
        mercury_user_attribution_id: Cookies.get('user_attribution_id'),
      };

      axios
        .get(`${process.env.GATSBY_MARKETING_BACKEND_BASE_URL}/signup-google-sso?state=${key}`)
        .then(response => {
          Cookies.set(key, JSON.stringify(cookieData), { domain: domain });
          resolve(response);
        })
        .catch(error => {
          reject(error);
          console.log('error', error);
        });
    });
  }

  static checkPlace(formData) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.GATSBY_MARKETING_BACKEND_BASE_URL}/check-place?place_id=${formData.place_id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
          console.log('error', error);
        });
    });
  }

  static vero(formData, formType) {
    return new Promise((resolve, reject) => {
      // temporary during vero to hubspot conversion
      // add MS formTypes here to jump over to hubspot instead of vero
      const convertedExternalForms = [
        'employeeCertificateDownload',
        'freeTimeCardCalculatorDownload',
        'blogSubscription',
        'eventSubscription',
        'partnersContact',
        'contentDownload',
        'webinarRecording',
      ]; // ex: 'employeeCertificateDownload'
      if (convertedExternalForms.includes(formType)) {
        return this.hubspot(formData, formType);
      }

      let endPoint = '';

      if (formType === 'blogSubscription') {
        endPoint = `${process.env.GATSBY_VERO_BLOG_SUBSCRIPTION}`;
      } else if (formType === 'newsletterSubscription') {
        endPoint = `${process.env.GATSBY_VERO_NEWSLETTER_SUBSCRIPTION}`;
      } else if (formType === 'contentDownload') {
        endPoint = `${process.env.GATSBY_VERO_CONTENT_DOWNLOAD}`;
      } else if (formType === 'FOWSubscription') {
        endPoint = `${process.env.GATSBY_VERO_FOW_SUBSCRIPTION}`;
      } else if (formType === 'employeeCertificateDownload') {
        endPoint = `${process.env.GATSBY_VERO_EMPLOYEE_CERTIFICATE}`;
      } else if (formType === 'webinarRecording') {
        endPoint = `${process.env.GATSBY_VERO_WEBINAR_RECORDING}`;
      } else if (formType === 'partnersContact') {
        endPoint = `${process.env.GATSBY_VERO_PARTNERS_CONTACT}`;
      } else if (formType === 'HWIcontentDownload') {
        endPoint = `${process.env.GATSBY_VERO_HOURLY_WORKFORCE_INDEX_CONTENT_DOWNLOAD}`;
      } else if (formType === 'eventSubscription') {
        endPoint = `${process.env.GATSBY_VERO_EVENT_SUBSCRIPTION}`;
      } else if (formType === 'freeTimeCardCalculatorDownload') {
        endPoint = `${process.env.GATSBY_VERO_FREE_TIME_CARD_CALCULATOR}`;
      }

      this.veroFormatData(formData, formType);

      const veroAPI = axios.create({
        baseURL: `${process.env.GATSBY_VERO_BASE}`,
        headers: {
          Accept: 'text/html',
          'Accept-Language': 'en-US,en;q=0.9',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      veroAPI
        .post(
          `${process.env.GATSBY_VERO_BASE}${endPoint}`,
          this.veroFormatData(formData, formType)
        )
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
          console.log('error section ', error);
        });
    });
  }

  static hubspot(formData, formType) {
    return new Promise((resolve, reject) => {
      let endPoint = '';
      let fields = [];

      // to get hubspot form endpoints, go to the form in hubspot and click the embed button
      // use the formId string
      switch (formType) {
        case 'employeeCertificateDownload':
          endPoint = `${process.env.GATSBY_HUBSPOT_EMPLOYEE_CERTIFICATE}`;
          fields = ['email', 'wiw_account_id', 'wiw_person_id', 'firstname', 'lastname', 'wiw_expected_users', 'pdf_download_url'];
          break;
        case 'contentDownload':
          endPoint = `${process.env.GATSBY_HUBSPOT_CONTENT_DOWNLOAD}`;
          fields = ['email', 'firstname', 'lastname', 'wiw_expected_users', 'pdf_download_url', 'content_title'];
          break;
        case 'freeTimeCardCalculatorDownload':
          endPoint = `${process.env.GATSBY_HUBSPOT_FREE_TIME_CARD_CALCULATOR}`;
          fields = ['email', 'pdf_download_url'];
          break;
        case 'eventSubscription':
          endPoint = `${process.env.GATSBY_HUBSPOT_EVENT_SUBSCRIPTION}`;
          fields = ['email'];
          break;
        case 'blogSubscription':
          endPoint = `${process.env.GATSBY_HUBSPOT_BLOG_SUBSCRIPTION}`;
          fields = ['email'];
          break;
        case 'partnersContact':
          endPoint = `${process.env.GATSBY_HUBSPOT_PARTNERS_CONTACT}`;
          fields = ['email', 'firstname', 'lastname', 'jobtitle', 'name', 'country', 'phone', 'website', 'numberofemployees', 'wiw_partner_service', 'wiw_estimated_number_of_mutual_customers', 'wiw_partner_contract_notes'];
          break;
        case 'webinarRecording':
          endPoint = `${process.env.GATSBY_HUBSPOT_WEBINAR_RECORDING}`;
          fields = ['email', 'firstname', 'lastname', 'company', 'webinar_url', 'webinar_title'];
          break;
      }

      const userName = {};
      if (formData.fullName) {
        userName.firstname = formData.fullName.split(' ')[0];
        userName.lastname = formData.fullName.split(' ').pop();
      }

      const data = {
        ...formData,
        ...userName,
        wiw_person_id: Cookies.get('W-PersonId') || '',
        wiw_account_id: Cookies.get('W-AccountId') || '',
      };


      const formattedData = Object.entries(data)
        .map(([k, v]) => this.hubspotFormatData(k, v))
        .filter(field => fields.includes(field.name));

      const hubspotAPI = axios.create({
        baseURL: `${process.env.GATSBY_HUBSPOT_BASE}`,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      hubspotAPI
        .post(
          `${process.env.GATSBY_HUBSPOT_BASE}${endPoint}`,
          { fields: formattedData }
        )
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
          console.log('error section ', error);
        });
    });
  }

  static hubspotFormatData(key, value) {
    if (key === 'industry') {
      value = value[0]; // just take the first selection
    }

    // objectTypeId value relates to hubspot's object type.
    const getObjectTypeId = key => {
      const wiwAccountProperties = ['wiw_account_id'];
      const companyProperties = ['name', 'country', 'website', 'numberofemployees', 'wiw_partner_service', 'wiw_estimated_number_of_mutual_customers', 'wiw_partner_contract_notes'];

      if (wiwAccountProperties.includes(key)) {
        return '2-4011273'; // HubSpot wiw_account Property
      }
      if (companyProperties.includes(key)) {
        return '0-2'; // HubSpot Company Property
      }
      
      return '0-1'; // HubSpot Contact Property
    };

    const mappedName = {
      companySize: 'wiw_expected_users',
      pdfDownloadUrl: 'pdf_download_url',
      ref_employees: 'wiw_expected_users',
      downloadUrl: 'pdf_download_url',
      jobTitle: 'jobtitle',
      companyName: 'name',
      numberOfEmployees: 'numberofemployees',
      companyWebsite: 'website',
      customerCount: 'wiw_estimated_number_of_mutual_customers',
      industry: 'wiw_partner_service',
      phoneNumber: 'phone',
      userMessage: 'wiw_partner_contract_notes',
      contentTitle: 'content_title',
      webinarPageUrl: 'webinar_url',
      webinarTitle: 'webinar_title',
    }

    const convertedKey = mappedName[key] || key;

    return {
      objectTypeId: getObjectTypeId(convertedKey),
      name: convertedKey,
      value,
    };
  }

  static veroFormatData(formData, formType) {
    const fullNameArray = compact(formData.fullName.split(' '));
    const lastIndex = fullNameArray.length - 1; // if they type in their full name as more than two words this will grab the last word as their lastname

    const parameters = {
      email: formData.email,
    };

    if (
      formType === 'newsletterSubscription' ||
      formType === 'blogSubscription' ||
      formType === 'FOWSubscription'
    ) {
      parameters['user[id]'] = Cookies.get('W-UserId')
        ? Cookies.get('W-UserId')
        : formData.email;
    } else if (formType === 'contentDownload') {
      parameters['user[id]'] = Cookies.get('W-UserId')
        ? Cookies.get('W-UserId')
        : formData.email;
      parameters['content_title'] = formData.contentTitle;
      parameters['downloadable_url'] = formData.downloadUrl;
      parameters['user[first_name]'] = fullNameArray[0];
      parameters['user[last_name]'] = fullNameArray[lastIndex];
      parameters['user[expected_employees]'] = formData.ref_employees;
    } else if (formType === 'freeTimeCardCalculatorDownload') {
      parameters['downloadable_url'] = formData.downloadUrl;
    } else if (formType === 'employeeCertificateDownload') {
      parameters['user[id]'] = Cookies.get('W-UserId')
        ? Cookies.get('W-UserId')
        : formData.email;
      parameters['user[account_id]'] = Cookies.get('W-AccountId') ?? '';
      parameters['user[person_id]'] = Cookies.get('W-PersonId') ?? '';
      parameters['user[first_name]'] = fullNameArray[0];
      parameters['user[last_name]'] = fullNameArray[lastIndex];
      parameters['user[expected_employees]'] = formData.companySize;
      parameters['event[pdf_download_url]'] = formData.pdfDownloadUrl;
    } else if (formType === 'webinarRecording') {
      parameters['user[first_name]'] = fullNameArray[0];
      parameters['user[last_name]'] = fullNameArray[lastIndex];
      parameters['user[company]'] = formData.companyName;
      parameters['event[webinar_url]'] = formData.webinarPageUrl;
      parameters['event[webinar_title]'] = formData.webinarTitle;
    } else if (formType === 'HWIcontentDownload') {
      parameters['event[report_url]'] = formData.downloadUrl;
      parameters['user[id]'] = Cookies.get('W-UserId')
        ? Cookies.get('W-UserId')
        : formData.email;
      parameters['content_title'] = formData.contentTitle;
    } else if (formType === 'partnersContact') {
      parameters['user[first_name]'] = fullNameArray[0];
      parameters['user[last_name]'] = fullNameArray[lastIndex];
      parameters['user[partnership_job_title]'] = formData.jobTitle;
      parameters['user[company]'] = formData.companyName;
      parameters['user[partnership_country]'] = formData.country;
      parameters['user[partnership_address]'] = formData.address;
      parameters['user[expected_employees]'] = formData.companySize;
      parameters['user[partnership_company_website]'] = formData.companyWebsite;
      parameters['user[partnership_customer_count]'] = formData.customerCount;
      parameters['user[partnership_industry]'] = formData.industry;
      parameters['user[partnership_phone]'] = formData.phoneNumber;
      parameters['user[partnership_user_message]'] = formData.userMessage;
    }
    // send today's date
    if (formType === 'FOWSubscription') {
      parameters['event[fow_subscribed_at]'] = todaysDate();
      parameters['user[fow_subscribed_at]'] = todaysDate();
    } else if (formType === 'blogSubscription') {
      parameters['event[blog_subscribed_at]'] = todaysDate();
      parameters['user[blog_subscribed_at]'] = todaysDate();
    }
    const searchParams = Object.keys(parameters)
      .map(key => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(
          parameters[key]
        )}`;
      })
      .join('&');

    return searchParams;
  }

  static formatData(formData) {
    const fullNameArray = compact(formData.fullName.split(' '));
    const lastIndex = fullNameArray.length - 1; // if they type in their full name as more than two words this will grab the last word as their lastname

    let ref_page = null;
    if (windowCheck) {
      if (window.currentLocation === '/') {
        ref_page = 'homepage';
      } else {
        ref_page = window.currentLocation;
      }
    }

    const formattedData = {
      account_id: null,
      first_name: fullNameArray[0],
      last_name: fullNameArray[lastIndex],
      phone_number: formData.phone,
      email: formData.email,
      ref_employees: parseInt(formData.ref_employees, 10),
      industry_id: parseInt(formData.industry_id, 10),
      company: formData.company,
      place: {
        business_name: formData.company,
        address: formData.address,
        street_name: formData.street_name,
        street_number: formData.street_number,
        locality: formData.locality,
        sub_locality: formData.sub_locality,
        region: formData.region,
        postal_code: formData.postal_code,
        country: formData.country,
        latitude: parseFloat(formData.latitude),
        longitude: parseFloat(formData.longitude),
        place_type: formData.place_type,
        place_id: formData.place_id,
        formatted_phone_number: formData.formatted_phone_number,
        international_phone_number: formData.international_phone_number,
        website: formData.website,
      },
      ref_page: ref_page,
      ref_plan_id: formData.ref_plan_id,
      trial_length: formData.trialLength,
      plan_feature: formData.plan_feature === '' ? null : formData.plan_feature,
      return_token: formData.return_token,
      response_token: formData.response_token,
      mercury_user_attribution_id: Cookies.get('user_attribution_id'),
      experiments: formData.LDFlags,
      timezone_id: formData.timezone_id,
      allow_duplicate_place: true,
    };

    return formattedData;
  }

  static zapier(formData) {
    return new Promise((resolve, reject) => {
      const cleanFullName = formData.fullName.replace(
        /^(M(?:is)?s|(?:Mrs?)[. ])/,
        ''
      );
      const fullNameArray = compact(cleanFullName.split(' '));
      const firstName = fullNameArray[0];
      const lastName = join(fullNameArray.slice(1), ' ');

      const params = {
        email: formData.email,
        first_name: firstName,
        last_name: lastName,
        phone: formData.phone,
        industry: parseInt(formData.industry_id, 10),
        employees: parseInt(formData.ref_employees, 10),
        company: formData.company,
        message: formData.message,
        return_token: formData.response_token !== '' ? true : false,
        response_token: formData.response_token,
        Campaign_ID: '7012G000001dXJjQAM',
      };

      let searchParams = Object.keys(params) // Vero needs their data sent like this
        .map(key => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(
            params[key]
          )}`;
        })
        .join('&');

      searchParams = searchParams.split('%20').join('+');

      const api = axios.create({
        baseURL: `${process.env.GATSBY_REQUESTINFO_ENDPOINT}`,
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
          'Accept-Language': 'en-US,en;q=0.9',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      api
        .post(api.baseUrl, searchParams)
        .then(data => {
          resolve(data);
          console.table('resolve section, ', data);
        })
        .catch(error => {
          reject(error);
          console.log('error section');
        });
    });
  }
}

export default API;
